"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = 1; // Riyadh Airport T5 branch
